module.exports = __webpack_public_path__ + "img/diving-bullseye.01391d61a2f5057845e33b95edc8ec9f.jpg";